import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import {
  Input,
  FormLabel,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { formatDate, formatTime } from "../../extends/NumberFormat";
import { WideColorButton } from "../ColorButtons/ColorButtons";
import { CheckCircle } from "@mui/icons-material";
import { UserContext } from "../../UserContext";
import { httpPost } from "../../hooks/http";
const styles = {
  padding: {
    padding: 10,
    marginTop: 10,
  },
  margin: {
    marginTop: 10,
    color: "white",
  },
  color: {
    color: "#5CB85C",
  },
  black: {
    color: "black",
  },
  colorUnderline: {
    borderBottom: `1px solid #0091ff`,
    "&:before": {
      borderBottom: `1px solid #0091ff`,
    },
    "&:after": {
      borderBottom: `1px solid #0091ff`,
    },
  },
};

const ApproveForm = (props) => {
  const { classes, guests, eventId, eventClientPortal } = props;
  const { access_token, settings } = useContext(UserContext);

  const [guestCount, setGuestCount] = useState(guests);
  const [approvedValue, setApprovedValue] = useState(
    eventClientPortal.approvedBy ? eventClientPortal.approvedBy : ""
  );
  const [loaded, setLoaded] = useState(true);
  const inputChange = (e) => {
    if (e.target.value <= 0) return 0;
    setGuestCount(e.target.value);
  };

  const approveEvent = async () => {
    setLoaded(false);

    let approve = {
      approvedBy: approvedValue,
    };

    if (settings) approve.finalGuestCount = guestCount;

    await httpPost(
      `events/${eventId}/clientportal/approve`,
      approve,
      access_token
    ).then((result) => {
      setApprovedValue(result.response.approvedBy);
      eventClientPortal.isApproved = true;
      eventClientPortal.approvalDate = result.response.approvalDate;
      setLoaded(result.loaded);
    });
  };

  return (
    <Grid container justifyContent="center" alignItems="center">
      {loaded ? (
        <Grid item xs={12}>
          <Grid item xs={12} sm={4}>
            <FormLabel className={classes.black} component="legend">
              Approved By :
            </FormLabel>
            <Input
              fullWidth
              onChange={(e) => setApprovedValue(e.target.value)}
              value={approvedValue}
              classes={{
                underline: classes.colorUnderline,
              }}
              inputProps={{
                "aria-label": "Description",
              }}
              readOnly={eventClientPortal.isApproved}
            />
          </Grid>

          {settings ? (
            <Grid item xs={12} sm={4} className={classes.margin}>
              <FormLabel className={classes.black} component="legend">
                Final Guest Count:
              </FormLabel>
              <Input
                defaultValue={guests}
                onChange={inputChange}
                fullWidth
                classes={{
                  underline: classes.colorUnderline,
                }}
                inputProps={{
                  "aria-label": "Description",
                }}
                type="number"
                readOnly={eventClientPortal.isApproved}
              />
            </Grid>
          ) : null}

          {eventClientPortal.isApproved ? (
            <Grid item xs={12} sm={4} className={classes.margin}>
              <FormLabel className={classes.black} component="legend">
                Approval Date:
              </FormLabel>
              <Input
                defaultValue={
                  formatDate(eventClientPortal.approvalDate) +
                  " @ " +
                  formatTime(eventClientPortal.approvalDate)
                }
                fullWidth
                classes={{
                  underline: classes.colorUnderline,
                }}
                inputProps={{
                  "aria-label": "Description",
                }}
                readOnly={eventClientPortal.isApproved}
              />
            </Grid>
          ) : null}

          <Grid
            container
            justifyContent="center"
            alignContent="center"
            alignItems="center"
          >
            <Grid item className={classes.margin}>
              {!eventClientPortal.isApproved ? (
                <WideColorButton
                  variant="outlined"
                  size="large"
                  onClick={() => approveEvent()}
                >
                  Approve Now
                </WideColorButton>
              ) : (
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item>
                    <CheckCircle className={classes.color} />
                  </Grid>
                  <Grid item>
                    <Typography variant="h6"> Approved</Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <CircularProgress />
      )}
    </Grid>
  );
};

ApproveForm.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(ApproveForm);
